import React, { useEffect } from 'react';

import { deckmaLogo, mailSolid, phoneSolid } from 'assets/images';
import { HEADER_NAVIGATION } from 'constants/headerNavigation';
import { useAppDispatch, useAppSelector } from 'hooks';
import { getUser, signOut } from 'store/thunks';

import './Header.scss';
import { CustomButton } from 'components/CustomButton';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants/routes';

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getUser());
  }, []);

  return (
    <div className="header-container">
      <div className="contacts">
        <div className="contacts__box">
          <img src={phoneSolid} alt="phone_icon" width="15px" height="15px" />
          <a href="tel:+49405488760">+ 49 40 5488760</a>
        </div>
        <div className="contacts__box">
          <img src={mailSolid} alt="mail_icon" width="15px" height="15px" />
          <a href="mailto:post@deckma.com">post@deckma.com</a>
        </div>
        {user && (
          <div className="contacts__box">
            <a href={ROUTES.profile} className="profile">
              {user.email}
            </a>
            <CustomButton
              text="Logout"
              width="100px"
              height="25px"
              onClick={() =>
                dispatch(signOut()).then(() =>
                  navigate(ROUTES.login, { replace: true })
                )
              }
            />
          </div>
        )}
      </div>
      <div className="navigation">
        <div className="navigation__logo-box">
          <a href={ROUTES.create_authorized}>
            <img
              src={deckmaLogo}
              alt="deckma_logo"
              width="230px"
              height="58px"
            />
          </a>
        </div>
        <div className="navigation__menu">
          <ul className="navigation__menu-list">
            {HEADER_NAVIGATION.map(({ link, name }) => (
              <li className="navigation__menu-text" key={name}>
                <a href={link}>{name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
